import { useMutation, useQuery } from '@tanstack/react-query';
import { projectIntakeApi } from '../lib/api.js';
import type { CreateProjectInput } from '../types/project-intake.js';

/**
 * 起票フォームの選択肢（事業・チーム・メンバー）を取得するフック。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件起票フォームのプルダウン選択肢を TanStack Query 経由で取得する
 * @graph-connects projectIntakeApi.getOptions [calls] 起票フォームの選択肢取得 API
 */
export function useProjectIntakeOptions(enabled = true) {
  return useQuery({
    queryKey: ['project-intake', 'options'],
    queryFn: () => projectIntakeApi.getOptions(),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}

/**
 * 案件を起票するミューテーションフック。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件起票（Backlog チケット + Slack チャンネル + 案件仕様書）を実行する
 * @graph-connects projectIntakeApi.createProject [calls] 起票実行 API
 */
export function useCreateProject() {
  return useMutation({
    mutationFn: (input: CreateProjectInput) => projectIntakeApi.createProject(input),
  });
}
